import { useState } from 'react';
import TechChatBot from '../../components/tech-chatbot';

const WhereIsMyTech: React.FC = () => {
	const [showChat, setShowChat] = useState(true);
	const [stepTwo, setStepTwo] = useState(false);

	const closeChatBot = () => {
		setShowChat(false);
	};
	const handleStepBack = () => {
		setStepTwo(false);
	};
	const handleStepChange = () => {
		setStepTwo(true);
	};

	return (
		<>
			<div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
				<h1 className="text-lg font-semibold leading-6 mb-4 text-gray-900">Where is my tech</h1>
				{/* {showChat && <ChatComponent />} */}
				{showChat && <TechChatBot closeChatBot={closeChatBot} step={stepTwo} />}
			</div>
		</>
	);
};
export default WhereIsMyTech;
